
<template>
  <div class="reserva">
    <Headers></Headers>
    <div class="center">
      <div class="reserva-first">
        <div class="first-layer"></div>
        <div class="first-title">
          音乐窝MusicWOW
          <p>向全国招募品牌合伙人</p>
        </div>
        <img src="https://aliyunosszs.musicwow.com/APPimg/league/bg.png" />
      </div>
      <div class="reserva-title">
        <P>预约加盟</P>
        <div class="form-show"></div>
      </div>
      <div class="reserva-form">
        <div class="form-name">
          <div class="name-user">姓名</div>
          <div class="name-input">
            <el-input
              suffix-icon="el-icon-user"
              placeholder="请输入"
              v-model="name"
            >
            </el-input>
          </div>
        </div>
        <div class="form-phone">
          <div class="phone-text">电话</div>
          <div class="phone-input">
            <el-input
              suffix-icon="el-icon-mobile-phone"
              type="number"
              placeholder="请输入"
              v-model="phone"
            >
            </el-input>
          </div>
        </div>
        <div class="form-map">
          <div class="map-title">加盟地区</div>
          <div class="map-add" @click="handMapAddBut">{{ address }}</div>
        </div>
        <div class="form-head">加盟方案选择</div>
        <div class="form-scheme">
          <div class="scheme-one">
            <div class="one-title">{{ planOneTitle.name }}</div>
            <ul class="schemeOneList">
              <li class="one-li" v-for="(item, key) in planOne">
                <div class="li-show"></div>
                <div>{{ item.title }}</div>
              </li>
            </ul>
            <div
              :class="type == 1 ? 'selectShow' : 'one-but'"
              @click="handOneSelectBut(planOneTitle.id)"
            >
              选择方案
            </div>
          </div>
          <div class="scheme-one">
            <div class="one-title">{{ planTwoTitle.name }}</div>
            <ul class="schemeOneList">
              <li class="one-li" v-for="(item, key) in planTwo">
                <div class="li-show"></div>
                <div>{{ item.title }}</div>
              </li>
            </ul>
            <div
              :class="type == 2 ? 'selectShow' : 'one-but'"
              @click="handTwoSelectBut(planTwoTitle.id)"
            >
              选择方案
            </div>
          </div>
        </div>
        <div class="form-addBut" @click="handFormBut()">提交申请 ></div>
      </div>

      <div class="map-hide" @click="bandMapHideBUt" v-show="mapHide"></div>
      <div class="map-show" v-show="mapShow">
        <p>{{ address }}</p>
        <!-- <v-distpicker type="mobile" @selected="onSelected()"></v-distpicker> -->
        <v-distpicker
          type="mobile"
          @selected="onSelected"
          :static-placeholder="static"
        ></v-distpicker>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>
<script>
import Headers from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import VDistpicker from "v-distpicker";
export default {
  components: {
    Headers,
    Footer,
    VDistpicker,
  },
  name: "reserva",
  data() {
    return {
      address: "请选择地址",
      distId: "",
      type: "",
      mapShow: false,
      mapHide: false,
      static: true,
      name: "",
      phone: "",
      province: "",
      area: "",
      city: "",
      planOne: [],
      planTwo: [],
      planOneTitle: "",
      planTwoTitle: "",
    };
  },
  methods: {
    handOneSelectBut(type) {
      this.type = type;
      // console.log(type)
    },
    handTwoSelectBut(type) {
      this.type = type;
      // console.log(type)
    },
    handMapAddBut() {
      this.mapShow = true;
      this.mapHide = true;
    },
    onSelected(data) {
      // console.log(data)
      this.address =
        data.province.value + " | " + data.city.value + " | " + data.area.value;
      this.province = data.province.value;
      this.city = data.city.value;
      this.area = data.area.value;
    },
    bandMapHideBUt() {
      this.mapShow = false;
      this.mapHide = false;
    },
    async handFormBut() {
      let that = this;
      await that.$API
        .getSaveData({
          username: that.name,
          phone: that.phone,
          region: that.province,
          city: that.city,
          county: that.area,
          plan_id: that.type,
        })
        .then(function (res) {
          // console.log(res)
          if (res.code == 200) {
            window._agl && window._agl.push(["track", ["success", { t: 3 }]]);
            that.$router.push({ name: "ReservationYes" });
            // window.location.href = '/#/ReservationYes'
          } else {
            that.$notify.error({
              message: res.msg,
              showClose: true,
              duration: 1500,
              offset: 200,
            });
          }
        });
    },
  },
  async mounted() {
    let PlanData = await this.$API.getPlanData({});
    // console.log(PlanData)
    let planOneList = [];
    let planTwoList = [];
    planOneList = PlanData.data[0];
    planTwoList = PlanData.data[1];
    this.planOne = planOneList.planlist;
    this.planTwo = planTwoList.planlist;
    this.planOneTitle = planOneList;
    this.planTwoTitle = planTwoList;
    // console.log(this.planOne)
    // console.log(this.planTwoTitle)
  },
};
</script>
<style lang="sass" scoped>
.reserva
  width: 100%
  height: 100%
  .center
    padding-top: 50px
    .reserva-first
      position: relative
      width: 100%
      .first-layer
        position: absolute
        width: 100%
        height: 100%
        background: rgba(0,0,0,0.2)
      .first-title
        position: absolute
        color: #fff
        font-size: 18px
        left: 25%
        top: 30%
        p
          margin-top: 10px
      img
    .reserva-title
      padding: 40px 0
      p
        font-size: 24px
        margin-bottom: 20px
      .form-show
        width: 44px
        height: 5px
        background: #07D1AA
        margin: auto
    .reserva-form
      padding-bottom: 50px
      .form-name,.form-phone
        display: flex
        padding: 10px 0
        .name-user,.phone-text
          font-size: 18px
          line-height: 35px
          color: rgba(0,0,0,0.5)
          width: 80px
      .form-map
        display: flex
        margin: 20px
        font-size: 18px
        color: rgba(0,0,0,0.5)
        .map-add
          margin-left: 30px

      .form-scheme>div
        margin: auto
        width: 171px
        box-shadow: 0px 6px 10px 0px rgba(225,227,232,1)
        border-radius: 3px
        padding-bottom: 20px
      .form-head
        font-size: 18px
        padding: 18px 0
      .form-scheme
        display: flex
        text-align: left
        padding-bottom: 30px
        .scheme-one
          position: relative
          height: 240px
          .one-title
            background: #07D1AA
            height: 17px
            line-height: 17px
            color: #fff
            padding: 10px
          .schemeOneList::-webkit-scrollbar
            display: none

          ul
            overflow-y: scroll
            background: #fff
            height: 128px
            line-height: 25px
            margin-top: 10px
            padding: 10px
            font-size: 12px
            li
              display: flex
              .li-show
                width: 3px
                height: 3px
                border-radius: 50%
                background: #07D1AA
                margin-top: 10px
                margin-right: 10px
            .one-li-hide
              margin-left: 12px
              color: #C5CCD6
          .one-but
            font-size: 12px
            margin: auto
            width: 146px
            height: 25px
            border-radius: 13px
            border: 1px solid rgba(151,151,151,1)
            color: rgba(0,0,0,0.5)
            text-align: center
            line-height: 25px
            position: absolute
            top: 80%
            left: 6%
          .selectShow
            background: #07D1AA
            color: #fff
            border: none
            text-align: center
            line-height: 25px
            font-size: 12px
            margin: auto
            width: 146px
            height: 25px
            border-radius: 13px
            position: absolute
            top: 80%
            left: 6%
      .form-addBut
        width: 222px
        height: 39px
        background: rgba(7,209,170,1)
        border-radius: 20px
        color: #fff
        font-size: 18px
        margin: auto
        line-height: 39px
  .map-hide
    position: fixed
    width: 100%
    height: 100%
    z-index: 888
    background: rgba(0, 0, 0, 0.2)
    top: 0
    bottom: 0
    left: 0
    right: 0
  .map-show
    position: fixed
    z-index: 999
    bottom: 0
    width: 100%
    height: 300px
    overflow-y: scroll
    background: #fff
    p
      padding: 20px 0
      color: #07D1AA
</style>

